import React, { Component } from "react";
import { Button, Space, InputNumber } from "antd";
import { toast } from "react-toastify";

import { updateHmcData } from "../../../actions/biochem";
import "./Biochem.css";

class HmcData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      loading: false,
      invalidInput: false,
    };
  }

    handleChange = (value) => {
      this.setState({
        inputValue: value || "",
        invalidInput: false,
      });
    }

    async handleSubmit() {
      const { data, generateHmcData, disableUserInput } = this.props;
      const { inputValue } = this.state;
      const { genista_id } = data;
      const value = inputValue.toString();

      if (value.length === 0) {
        this.setState({ invalidInput: true });
        toast.error("Please enter a result");
        return;
      }

      try {
        this.setState({ loading: true });
        disableUserInput(true);

        const response = await updateHmcData(genista_id, value);

        if (response && response.success) {
          this.setState({
            inputValue: "",
            invalidInput: false,
            loading: false,
          });
          generateHmcData();
          disableUserInput(false);
          toast.success("Success!");
        } else {
          toast.error(response?.message || "Something went wrong");
          this.setState({ loading: false });
          disableUserInput(false);
        }
      } catch (error) {
        toast.error("Failed to update result");
        this.setState({ loading: false });
        disableUserInput(false);
      }
    }

    render() {
      const { data } = this.props;
      const {
        loading, inputValue, invalidInput,
      } = this.state;
      const { genista_id, sample_id, sample_type } = data;
      const error = invalidInput ? "error" : "";
      return (
        <div className="HMCData">
          <div className="HMC__Label_Container">
            <p>
              <span className="HMC__Label"> Genista ID: </span>
              {genista_id}
            </p>
            <p>
              <span className="HMC__Label"> Sample Type: </span>
              {sample_type}
            </p>
          </div>
          <p>
            <span className="HMC__Label"> Sample ID: </span>
            {sample_id}
          </p>
          <Space.Compact>
            <InputNumber
              className="HMC__Input"
              type="number"
              status={error}
              onPressEnter={() => this.handleSubmit()}
              onChange={(value) => this.handleChange(value)}
              value={inputValue}
              placeholder="Result"
            />
            <Button type="primary" onClick={() => this.handleSubmit()} loading={loading}>Submit</Button>
          </Space.Compact>
        </div>
      );
    }
}

export default HmcData;
